import { SET_SCROLL_POSITION } from '../../constants/actions';

const initialState = {
  matchesScrollPosition: 0,
  myLikesScrollPosition: 0,
  mutualLikesScrollPosition: 0,
  likesMeScrollPosition: 0,
  myViewsScrollPosition: 0,
  viewedMeScrollPosition: 0,
  searchScrollPosition: 0,
  whosOnlineRecentScrollPosition: 0,
  whosOnlineWeekScrollPosition: 0,
  browseScrollPosition: 0,
  myFavoritesScrollPosition: 0,
  favoritedMeScrollPosition: 0
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_SCROLL_POSITION:
      return { ...state, ...action.data };
    default:
      return state;
  }
}
